module.exports = __webpack_public_path__ + "img/empty.d7ca7e7e.svg";